import InfoIcon from '@material-ui/icons/Info';
import React from 'react';
import styled from 'styled-components';
import { Tooltip } from '../Tooltip';

const StyledIcon = styled(InfoIcon)<{ $ml?: boolean; $mr?: boolean }>`
    color: ${props => props.theme.palette.grey[400]};
    font-size: ${props => props.theme.typography.body1.fontSize};

    ${props => props.$ml && `margin-left: ${props.theme.spacing(1)}px;`}
    ${props => props.$mr && `margin-right: ${props.theme.spacing(1)}px;`}
`;

export type InfoTooltipProps = {
    children: Exclude<React.ReactNode, null | undefined>;
    ml?: boolean;
    mr?: boolean;
    role?: string;
};

export function InfoTooltip({ children, ml, mr, role }: InfoTooltipProps): JSX.Element {
    return (
        <Tooltip tip={children} variant="info">
            <StyledIcon $ml={ml} $mr={mr} aria-hidden="false" role={role} />
        </Tooltip>
    );
}
InfoTooltip.displayName = 'InfoTooltip';
